/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Quota_UnlimitedInputs */

const en_directory_submit_quota_unlimited = /** @type {(inputs: Directory_Submit_Quota_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited submissions (Sponsor plan).`)
};

const zh_directory_submit_quota_unlimited = /** @type {(inputs: Directory_Submit_Quota_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交额度不限（Sponsor 套餐）。`)
};

/**
* | output |
* | --- |
* | "Unlimited submissions (Sponsor plan)." |
*
* @param {Directory_Submit_Quota_UnlimitedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_quota_unlimited = /** @type {((inputs?: Directory_Submit_Quota_UnlimitedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Quota_UnlimitedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_quota_unlimited(inputs)
	return zh_directory_submit_quota_unlimited(inputs)
});
export { directory_submit_quota_unlimited as "directory.submit.quota_unlimited" }